export interface AffiliationList {
  affiliationId: string;
  affiliationTypeCode: string;
  affiliationTypeDesc: string;
}

export interface SkyClubRequest {
  affiliationList: AffiliationList[];
}

export interface VisitRecord {
  axUniqueId: string;
  productType: string;
  affiliationId: string;
  affiliationTypeCode: string;
  affiliationTypeDesc: string;
  annualVisitAllotment: number;
  visitsUsed: number;
  thresholdMetInd: boolean;
  visitScaleInd: string;
  lastUpdateGmt: number;
}

export interface SkyClubResponse {
  visitRecord: VisitRecord[];
}
